import { gate } from 'hub-http/gates';
export const GATES = {
  SEO_ADD_CUSTOM_KB_TITLE: 'SEO:AddCustomKBTitle',
  KNOWLEDGE_BASE_V3_1: 'KnowledgeBase:V3.1',
  MANAGE_PRIVATE_CONTENT: gate('Permissions:KnowledgeBasePrivateContent'),
  USE_CORRECT_THEME_SETTINGS_VARIANT: 'KnowledgeBaseV3:ThemeSettingsVariant',
  KB_AGENT: gate('KnowledgeBase:KBAgent'),
  KNOWLEDGE_BASE_V3_MIGRATION: 'KnowledgeBase:V3Migration',
  ANALYTICS_UNIFIED_EVENT_SEARCH: gate('KnowledgeBase:V3Migration:Analytics'),
  LOCALIZED_ARTICLE_TITLE: gate('KnowledgeBase:Localization:ArticleTitle')
};
export const isUngatedForSeoKbTitle = gates => gates.includes(GATES.SEO_ADD_CUSTOM_KB_TITLE);
export const isUngatedForManagePrivateContentPermissions = gates => gates.includes(GATES.MANAGE_PRIVATE_CONTENT);
export const isUngatedForKnowledgeBaseV3_1 = gates => gates.includes(GATES.KNOWLEDGE_BASE_V3_1);
export const isUngatedForKBAgent = gates => gates.includes(GATES.KB_AGENT);
export const isUngatedForKBv3Migration = gates => gates.includes(GATES.KNOWLEDGE_BASE_V3_MIGRATION);
export const isUngatedForLocalizedArticleTitle = gates => gates.includes(GATES.LOCALIZED_ARTICLE_TITLE);